import { AppStoreContextWrapper, RouteContext } from '@common/contexts';
import { AuthApplicationKeys } from '@common/models/Enums';
import { AppStore } from '@common/stores';
import { buildAppRoute } from '@customer/components/routes';
import { AppLandingOutlet } from '@customer/views/.';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import { ErrorBoundary } from './views/error/ErrorBoundary';

const appStore = new AppStore(AuthApplicationKeys.PetPass, true); //todo change to key for customer app
AppStoreContextWrapper.set(appStore);
appStore.load();

//This is a separate component to prevent calling buildAppRoute before the configurationStore is in a loaded state
//this prevents needing complex reactions in stores that depend on the configuration being in a loaded state.
const RoutesComponent = observer(() => {
    const appRoutes = buildAppRoute(appStore);
    RouteContext.set(appRoutes);
    return useRoutes(appRoutes);
});

export const CustomerApp = observer(() => {
    const location = useLocation();

    const [route, setRoute] = useState({
        to: location.pathname,
        from: location.pathname
    });

    useEffect(() => {
        setRoute((prev) => ({ to: location.pathname, from: prev.to }))
    }, [location]);

    return (
        <ErrorBoundary route={route}>
            {
                !appStore.isConfigurationLoading ? <RoutesComponent /> : <AppLandingOutlet />
            }
        </ErrorBoundary>
    );
});

export default CustomerApp;
